<template>
  <div class="question-view ">
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" @onRenderComplete="mathjaxRes" :safe="false"/>
      </div>

      <div class="fill-list">
        <vue-mathjax :formula="html" @onRenderComplete="mathjaxRes" :safe="false"/>
      </div>
    </div>
    <div class="quest-img" v-if="form.img_url">
      <img :src="form.img_url" alt="">
    </div>
  </div>
</template>

<script>
import fillSum from '../../plugins/fill_sum'
import fillSumPlus from '../../plugins/fill_sum_plus'
import extractOverContent from '../../plugins/extractOverContent'
let pLeft = 'PARENTHESISLEFT', pRight = 'PARENTHESISRIGHT'

export default {
  props: ['form'],
  data() {
    return {
      html: '',

      mathjaxNum: 0
    }
  },
  methods: {
    mathjaxRes() {
      this.mathjaxNum ++
      if(this.mathjaxNum >= 2) this.$emit('onRenderComplete')
    },
    strConvertDom(data) {
      let regex = /\$\$([^$]*)\$\$|\$([^$]*)\$/g,
          regex2 = /@(.*?)#/g,
          regex3 = /#{2}(.*?)#{2}/g,
          regex4 = /\|(.*?)\|/g,
          regex5 = /(&amp;){2}(.*?)(&amp;){2}/g,
          regex02
      let matches = data.match(regex2);
      if (matches) {
        regex02 = matches.filter(function(match) {
          return !match.includes('\\left(') && !match.includes('\\right)');
        });
      }
      let regex03 = data.match(regex3),
          regex05 = data.match(regex5),
          regexMap = {
            over: /\$(([^$]*)\\over([^$]*))\$/,
            frac: /\$(([^$]*)\\frac([^$]*))\$/,
            overline: /\$(([^$]*)\\overline([^$]*))\$/,
            dfrac: /\$(([^$]*)\\dfrac([^$]*))\$/,
            overbrace: /\$(([^$]*)\\overbrace([^$]*))\$/,
          }

      if(regex05) {
        regex05.filter(its => {
          let itsCte = its.replaceAll('&amp;&amp;', '')

          if(regex4.test(itsCte)) {
            let [expression] = itsCte.match(regex4),
                content = itsCte.replace(expression, '')
            let echoHtml = `<span class="fill-box"><input type="text" class="fill ordinary"/></span>`
            let {newCte: equation} = fillSumPlus(content, expression)
            equation = equation.replace('()', echoHtml)
            data = data.replace(its, equation)
          }
        })
      }

      let regex04 = data.match(regex4)
      if(regex04) {
        regex04.filter(its => {
          let echoHtml = `<span class="fill-box"><input type="text" class="fill ordinary"/></span>`
          try {
            let equation = fillSum(its).replace('()', echoHtml)
            equation = equation.replace('/', '÷').replace('*', 'x')
            data = data.replace(its, equation)
          }
          catch(e) {
            console.log(e)
          }
        })
      }

      let regex01 = data.match(regex)

      if(regex01) {
        regex01.filter(its => {
          let frac = its.match(regexMap.frac)
              , overline = its.match(regexMap.overline)
              , overbrace = its.match(regexMap.overbrace)
              , dfrac = its.match(regexMap.dfrac)

          if(dfrac) {
            for(let i = 2; i < dfrac.length; i++) {
              let val = dfrac[i].match(regex2)
              dfrac[i] = dfrac[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              if(val) {
                val.filter(its => dfrac[i] = dfrac[i].replace(its, '龘'))
              }
            }

            let [, , otherL, content] = dfrac
                , cte = content.match(/\{([^}]+)\}/g)
                , child = ''
                , parent = ''
                , otherR = content || ''
            if(cte){
              cte.map((its, idx) => {
                let r = its.replace('{', '').replace('}', '')
                if(idx == 0) {
                  child = r
                  content = content.replace(its, '')
                } else {
                  parent = r
                  content = content.replace(its, '')
                }
              })
            }

            if(child != '' && parent != '') {
              otherR = content
            } else if(child != '') {
              let [p, ...o] = content.split('')
              parent = parent || p
              otherR = o.join('')
            } else {
              let [c, p, ...o] = content.split('')
              child = child || c
              parent = parent || p
              otherR = o.join('')
            }

            let groups = [otherL, child, parent, otherR]

            for(let g = 0; g < groups.length; g++) {
              let val = groups[g].match(/龘/g)
              if(val) {
                let [prevVal, nextVal] = groups[g].split(val[0])
                groups[g] = {fill: true, val: val, prevVal, nextVal}
              }
              else groups[g] = {fill: false, val: groups[g]}
            }

            let [l, c, p, r] = groups
            let echoHtml = `
              ${
                l.fill ? `${l.prevVal}<span class="fill-box"><input type="text" class="fill ordinary" /></span>${l.nextVal}` : l.val
            }
              <span class="some-as">
                ${ c.fill ?
                `
                    <span class="some-child">
                      <span>${c.prevVal}</span>
                      <span class="fill-box">
                        <input type="text" class="fill numerator">
                      </span>
                      <span>${c.nextVal}</span>
                    </span>
                    ` :
                c.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${c.val}</span>` :
                    `<span class="denominator">${c.val}</span>`}
                <span class="line"></span>
                ${ p.fill ?
                `
                    <span class="some-child">
                      <span>${p.prevVal}</span>
                      <span class="fill-box">
                        <input type="text" class="fill numerator">
                      </span>
                      <span>${p.nextVal}</span>
                    </span>
                    ` :
                p.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${p.val}</span>` :
                    `<span class="denominator">${p.val}</span>` }
              </span>
              ${
                r.fill ? `${r.prevVal}<span class="fill-box"><input type="text" class="fill ordinary" /></span>${r.nextVal}` : r.val
            }
            `
            data = data.replace(its, echoHtml)
          }

          if(overline) {
            for(let i = 2; i < overline.length; i++) {
              overline[i] = overline[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')
            }
            let [, , otherL, content] = overline
                , cte = content.match(/\{([^}]+)\}/g)
                , c = ''
                , otherR = content || ''
            if(cte){
              cte.map((its, idx) => {
                let r = its.replace('{', '').replace('}', '')
                if(idx == 0) {
                  c = r
                  otherR = otherR.replace(its, '')
                } else {
                  otherR = otherR.replace(its, r)
                }
              })
            } else {
              let [f, ...o] = content.split('')
              c = f || ''
              otherR = o.join('')
            }
            let echoHtml = `
              <span class="overline">
                <span>${otherL}</span>
                <span class="overline-content">${c}</span>
                <span>${otherR}</span>
              </span>
            `
            data = data.replace(its, echoHtml)
          }

          let over = its.match(regexMap.over)
          if(over && !overline && !overbrace) {
            let newOver = extractOverContent(over[1])
                , to_filter = /{([^{}]*)}/
                , overs = []

            if(newOver.length != 0) {
              let grade = newOver[0].split('\\over')
              overs = over[1].split(`{${newOver[0]}}`)
              for(let i = grade.length - 1; i >= 0; i--) {
                let otem = grade[i]
                    , matchRes = otem.match(to_filter)
                if(matchRes) {
                  otem = otem.replace(matchRes[0], matchRes[1])
                }
                overs.splice(1, 0, otem)
              }
            } else {
              newOver = over[1].match(to_filter)
              if(newOver && newOver[0].indexOf('\\over') > 0) {
                if(newOver) {
                  overs = over[1].split(newOver[0])
                  overs.splice(1, 0, ...newOver[1].split('\\over'))
                } else {
                  overs = ['', ...over[1].split('\\over'), '']
                }
              } else {
                overs = ['']
                for(let i = 2; i < over.length; i++) {
                  let otem = over[i]
                      , matchRes = otem.match(to_filter)
                  if(matchRes) {
                    otem = otem.replace(matchRes[0], matchRes[1])
                  }
                  overs.push(otem)
                }
              }
            }
            for(let i = 0; i < overs.length; i++) {
              let val = overs[i].match(regex2)
              overs[i] = overs[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              if(val) {
                let [prevVal, nextVal] = overs[i].split(val[0])
                overs[i] = {fill: true, val: val, prevVal, nextVal}
              }
              else overs[i] = {fill: false, val: overs[i]}
            }

            let [left, child, parent, right] = overs

            let echoHtml = `
            ${
                left.fill ? `<span class="fill-box"><input type="text" class="fill ordinary" /></span>` : left.val
            }
            <span class="some-as">
              ${ child.fill ?
                `
                  <span class="some-child">
                    <span>${child.prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill numerator">
                    </span>
                    <span>${child.nextVal}</span>
                  </span>
                  ` :
                child.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${child.val}</span>` :
                    `<span class="denominator">${child.val}</span>`}
              <span class="line"></span>
              ${ parent.fill ?
                `
                  <span class="some-child">
                    <span>${parent.prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill numerator">
                    </span>
                    <span>${parent.nextVal}</span>
                  </span>
                  ` :
                parent.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${parent.val}</span>` :
                    `<span class="denominator">${parent.val}</span>` }
            </span>
            ${
                (right && right.fill) ? `<span class="fill-box"><input type="text" class="fill ordinary" /></span>` : (right ? right.val : '')
            }
            `
            data = data.replace(its, echoHtml)
          }

          if(frac) {
            let [, , integer, fraction] = frac
                , fractionRegex = /\{.*?\}/g
                , [child, parent] = fraction.match(fractionRegex)
                .map(s => s.slice(1, -1))
                , other = fraction.replace(`{${child}}{${parent}}`, '')
            let echoData = [integer, child, parent, other]

            // 修复：统一@#处理逻辑，删除错误的逗号替换
            for(let i = 0; i < echoData.length; i++) {
              let val = echoData[i].match(regex2)
              echoData[i] = echoData[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              if(val) {
                let [prevVal, nextVal] = echoData[i].split(val[0])
                echoData[i] = {fill: true, val: val, prevVal, nextVal}
              } else echoData[i] = {fill: false, val: echoData[i]}
            }

            // 修复：统一fill-box结构，和正常代码一致
            let echoHtml = `
            <span class="mixed-number">
              ${ echoData[0].fill ?
                `
                  <span class="some-child">
                    <span>${echoData[0].prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill mixed">
                    </span>
                    <span>${echoData[0].nextVal}</span>
                  </span>
                  `:
                echoData[0].val.indexOf('<input') > -1 ?
                    `<span class="some-child">${echoData[0].val}</span>` :
                    `<span class="mixed">${echoData[0].val}</span>`}
              <span class="some-as">
                ${ echoData[1].fill ?
                `
                  <span class="some-child">
                    <span>${echoData[1].prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill numerator">
                    </span>
                    <span>${echoData[1].nextVal}</span>
                  </span>
                  `:
                echoData[1].val.indexOf('<input') > -1 ?
                    `<span class="some-child">${echoData[1].val}</span>` :
                    `<span class="denominator">${echoData[1].val}</span>` }
                <span class="line"></span>
                ${ echoData[2].fill ?
                `
                  <span class="some-child">
                    <span>${echoData[2].prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill denominator">
                    </span>
                    <span>${echoData[2].nextVal}</span>
                  </span>
                  ` :
                echoData[2].val.indexOf('<input') > -1 ?
                    `<span class="some-child">${echoData[2].val}</span>` :
                    `<span class="denominator">${echoData[2].val}</span>` }
              </span>
            </span>
            ${
                echoData[3].fill ? `<span class="fill-box"><input type="text" class="fill ordinary" /></span>` : echoData[3].val
            }
            `
            data = data.replace(its, echoHtml)
          }
        })
      }

      if(regex02) {
        regex02.filter(its => {
          let echoHtml = `<span class="fill-box"><input type="text" class="fill ordinary" /></span>`
          data = data.replace(its, echoHtml)
        })
      }

      if(regex03) {
        regex03.filter(its => {
          let val = its.replace(/##/g, '')
          let echoHtml = `<span class="fill-box"><input type="text" class="fill ordinary" value="${val}"/></span>`
          data = data.replace(its, echoHtml)
        })
      }

      return data.replaceAll(pLeft, '(').replaceAll(pRight, ')')
    },

  },
  mounted() {
    let content = JSON.parse(this.form.content)
    this.html = this.strConvertDom(content.topic)
  }
}
</script>

<style lang="scss">
.question-view {
  width: 100%;
  height: 100%;
  padding: 0px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    flex: 1;
    height: 100%;

    .title {
      font-size: 18px;
      color: #333;
    }

    .fill-list {
      width: 100%;
      margin-top: 20px;

      .single {
        height: fit-content;
        display: inline-block;
        margin-bottom: 5px;

        .label {
        }

        input[type="text"] {
          width: 100px;
          height: 40px;
          text-align: center;
          padding: 5px;
          box-sizing: border-box;
          font-size: 14px;
          font-weight: 700;
          border-radius: 10px;
          background-color: #fcd2ab;
          border: none;
          outline: none;
          box-sizing: border-box;
        }
      }
    }
  }

  .quest-img {
    width: 300px;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      border-radius: 5px;
    }
  }

  // 修复：新增fill-box样式，统一结构
  .fill-box {
    display: inline-block;
    border-radius: 10px;
    margin: 5px 0;
  }

  .ordinary {
    color: #333;
    margin: 5px 0;
  }
  .ordinary.fill {
    border-radius: 10px;
    background-color: #fcd2ab;
    outline: none;
    border: none;
    width: 100px;
    height: 40px;
    text-align: center;
    padding: 5px;
    box-sizing: border-box;
    margin-bottom: 5px;
    font-size: 16px;
  }

  .overline {
    display: flex;
    align-items: center;
    margin-top: 5px;

    .overline-content {
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #333;
      }
    }
  }

  .some-as {
    display: inline-block;
    margin: 0 5px;
    position: relative;
    color: #333;
    vertical-align: middle;

    .some-child {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .line {
      width: inherit;
      min-width: 30px;
      height: 1px;
      background-color: #333;
      display: block;
    }

    .numerator, .denominator {
      margin: 5px 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
    }

    .numerator.fill, .denominator.fill {
      border-radius: 10px;
      background-color: #fcd2ab;
      outline: none;
      border: none;
      width: 100px;
      height: 40px;
      text-align: center;
      padding: 5px;
      box-sizing: border-box;
    }
  }

  .mixed-number {
    display: inline-flex;
    align-items: center;
    .mixed {
      color: #333;
    }

    .mixed.fill {
      border-radius: 10px;
      background-color: #fcd2ab;
      outline: none;
      border: none;
      width: 100px;
      height: 40px;
      text-align: center;
      padding: 5px;
      color: #333;
    }
  }
}
</style>